<template>
  <div :style="{ backgroundImage: `url('' + require(@/assets/fundo.jpg)`+')' }" id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xl5 lg5 xs12 sm8 md5>
            <v-card id="tv-card" class="elevation-2">
              <v-toolbar style="display:block" height="160px">
                <v-toolbar-title id="toolbar">
                  <img :src="require(`@/assets/${imgTopo}`)" alt="Sistema Pré-Pago">
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-layout ma-4 pa-2 column>
                    <v-flex>
                      <v-text-field
                        v-model="login.cpf"
                        append-icon="person"
                        outline
                        color="grey dark-5"
                        clearable
                        name="cpf"
                        :rules="cpfRules"
                        counter="11"
                        mask="###########"
                        label="CPF"
                        id="cpf"
                        type="text"
                        required
                        autofocus
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="login.senha"
                        append-icon="vpn_key"
                        :rules="senhaRules"
                        name="password"
                        label="Senha"
                        color="grey dark-5"
                        id="password"
                        outline
                        clearable
                        type="password"
                        required
                        @keyup.enter.native="logar()"
                      ></v-text-field>

                      <!--<div class="error" v-if="!$v.login.senha.required">Validação </div>-->
                    </v-flex>
                    <v-progress-linear color="carregando" v-show="loading" :indeterminate="true"></v-progress-linear>
                    <v-flex class="text-xs-center">
                      <v-btn color="primary" large block @click="logar()" type="button">Acessar</v-btn>
                    </v-flex>

                    <v-flex>
                      <v-btn
                        small
                        flat
                        color="primary"
                        @click.stop="dialog = !dialog;loadingResetSenha=false;reset.email=''"
                      >Esqueceu a senha?</v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-flex xs12>
                  <img src="@/assets/assinaturatecnoweb.png" alt="Grupo Tecnoweb" class="mb-5">
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <v-snackbar
        :timeout="tempo"
        :color="error"
        :multi-line="'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
      >
        {{ textSnack }}
        <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
      </v-snackbar>

      <v-snackbar
        :timeout="10000"
        :color="sucesso"
        :multi-line="'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbarSuccess"
      >Você receberá um email com os procedimentos para redefinição de sua senha.
        <v-btn dark flat @click.native="snackbarSuccess = false">Fechar</v-btn>
      </v-snackbar>
    </v-content>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Esqueceu a Senha?</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="reset.email" label="E-mail" required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <small>*Campo requerido</small>
              <v-progress-linear
                :indeterminate="true"
                color="carregando"
                v-show="loadingResetSenha"
              ></v-progress-linear>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#EA9F12" @click.native="dialog = false">Cancelar</v-btn>
              <v-btn color="primary" @click.native=" enviaEmailForget()">Enviar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>




<script>
import { HTTP } from "../services/http.axios.js";
import { required, minLength, between } from "vuelidate/lib/validators";
import EventBus from "../services/EventBus";

export default {
  name: "login",
  data() {
    return {
      reset: {
        email: ""
      },
      imagemFundo: "@/assets/assinaturatecnoweb.png",
      cpfRules: [
        v => !!v || "Cpf é requerido",
        v => v.length == 11 || "Cpf Menor que o padrão"
      ],
      senhaRules: [v => !!v || "Senha é requerida"],
      textSnack: "",
      snackbar: false,
      snackbarSuccess: false,
      tempo: 5000,
      mode: "",
      info: "f1f1f1",
      error: "error",
      sucesso: "sucesso",
      loading: false,
      loadingResetSenha: false,
      dialog: false,
      login: {
        cpf: "",
        senha: ""
      }
    };
  },
  validations: {
    login: {
      cpf: {
        required,
        minLength: minLength(11)
      },
      senha: {
        required
      }
    }
  },
  created() {
    let currentUrl = window.location.hostname;
    let imgUrl = currentUrl.split(".");
    console.log(this.imgUrl);
    if (imgUrl[0] == "omminiprepago") {
      this.imgTopo = "logoLogin.png";
    } else {
      this.imgTopo = imgUrl[0] + ".png";
    }
  },
  mounted() {
    window.localStorage.setItem("tituloApp", "OMMINI PRÉ-PAGO");
    this.loadingResetSenha = false;
    //OMMINI Pre Pago
  },
  methods: {
    enviaEmailForget() {
      this.loadingResetSenha = true;
      HTTP.post(`password/email`, this.reset)
        .then(response => {
          console.log(response.data);

          this.dialog = false;
          this.snackbarSuccess = true;
          this.loadingResetSenha = true;
          this.$router.push("login");
        })
        .catch(e => {
          this.loadingResetSenha = false;
          if (!Array.isArray(e.response.data.errors)) {
            let itens = [];
            for (var prop in e.response.data.errors) {
              itens.push(e.response.data.errors[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.data.errors;
            this.snackbar = true;
          }
        });
    },

    openRota() {
      this.$router.push("Saldo");
    },

    logar() {
      this.loading = true;
      HTTP.post(`users/login/cliente`, this.login)
        .then(response => {
          if (response.data.error) {
            this.textSnack = response.data.error.cpf;
            this.snackbar = true;
          } else {
            window.sessionStorage.setItem("token", response.data.token);
            window.sessionStorage.setItem("nome", response.data.nome);
            window.sessionStorage.setItem("cpf", response.data.cpf_cnpj);
            window.sessionStorage.setItem("user", response.data.id);
            if (response.data.tipo == "P") {
              this.$router.push("bemvindo");
              return false;
            }

            HTTP.defaults.headers.common["authorization"] = `Bearer ${
              response.data.token
            }`;
            setTimeout(() => {
              this.loading = false;
              this.$router.push("Saldo");
            }, 1000);
            //return true;
          }

          //  console.log(response.data.token)
        })
        .catch(e => {
          this.loading = false;
          console.log("log" + e.response.data.error);

          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.data.error;
            this.snackbar = true;
          }
        });

      // this.textSnack = "Informe sua senha"
    }
  }
};
</script>






<style scoped>
#login {
  /*background-image: url("assets/assinaturatecnoweb.png");*/
  background-image: url("https://omminiprepago.com.br/static/img/fundo.jpg");
  background-size: cover;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495e;
}

#toolbar {
  text-align: center;
}

.v-toolbar__content {
  height: 184px !important;
}

#tv-card {
  border-radius: 5px;
}
.v-toolbar__content,
.v-toolbar__extension {
  display: block !important;
  padding: 34px;
}
.v-text-field--outline .v-input__slot {
  border: 0px solid #ccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue